import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getAllUsers } from './actions';
import querystring from 'querystring';
import UserListPage from './UserListPage';
import UserEditPage from './UserEditPage';
import Loading from '../common/components/Loading';

class Users extends Component {
  componentDidMount() {
    const { search } = this.props.location;
    const qs = search ? querystring.parse(search.slice(1)) : {};

    this.props.dispatch(getAllUsers(qs));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      const { search } = this.props.location;
      const qs = search ? querystring.parse(search.slice(1)) : {};

      this.props.dispatch(getAllUsers(qs));
    }
  }

  render() {
    const { match, loaded } = this.props;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}`} component={UserListPage} />
        <Route exact path={`${match.path}/:id`} component={UserEditPage} />
        <Redirect to={`${match.path}`} />
      </Switch>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    loaded: state.users.users.get('loaded'),
  };
};

export default connect(mapStateToProps)(Users);



// WEBPACK FOOTER //
// ./src/users/Users.js